import '../sass/app.scss';

import 'jquery';
import $ from 'jquery';
import 'bootstrap';
import 'bootstrap-select';//select下拉
import 'slick-carousel';//slick.js
import 'imgliquid/js/imgLiquid-min.js';
import AOS from 'aos';
import popper from 'popper.js';
import 'jquery-mousewheel';//mCustomScrollbar use
import mCustomScrollbar from 'malihu-custom-scrollbar-plugin';
import lightcase from 'lightcase';

//plugin
import './plugin/jQuery.gridder';
// import './plugin/lightcase.js';



